import React, { useCallback, useEffect } from 'react';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import * as Const from '../../utils/Const';
import { GetKeyEndTypes, GetSummaryRuleOptionId, GetOrgId } from '../../utils/UtilFunction';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DropdownMulti, Dropdown } from '../../components/dropdown';
import { useGetDashboardData, useGetDropdownData } from './api/fetchData';
import { GraphAreaStudyAdmin } from './GraphAreaStudyAdmin';
import Button from '@mui/material/Button';
import Sidebar from '../../components/sidemenu/Sidebar';

export function DashboardSelfStudyAdmin() {
  // const [summaryRuleList, setSummaryRuleList] = useState<{ key: string; value: string }[]>([]);
  // const [selectedSummaryRuleId, setSelectedSummaryRuleId] = useState<string>('');
  // const [selectedSummaryRuleName, setSelectedSummaryRuleName] = useState<string>('');
  // const [summaryRuleRowDropdownList, setSummaryRuleRowDropdownList] = useState<
  //   { id: number; name: string }[]
  // >([]);

  const defaultFromDate = new Date().setHours(0, 0, 0, 0);
  const defaultToDate = new Date().setHours(23, 59, 59, 999);
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [selectedEndTypes, setSelectedEndTypes] = useState<string[]>([Const.EndTypes[0].name]);
  const [summaryItems, setSummaryItems] = useState<string>('');
  const orgId = GetOrgId();
  const numberOfMaterialSummaryBarDataUrl = `${
    import.meta.env.VITE_DATA_POOLS_URL
  }/selectNumberOfMaterialSummaryBarData`;
  const numberOfMaterialSummaryTableDataUrl = `${
    import.meta.env.VITE_DATA_POOLS_URL
  }/selectNumberOfMaterialSummaryTableData`;

  // React Router の useSearchParams フックを使用
  const [searchParams, setSearchParams] = useSearchParams();

  const dataParams = {
    [Const.KeyOrgID]: orgId,
    [Const.KeyStartDatetimeUtc]: fromDate?.toJSON() || '',
    [Const.KeyEndDatetimeUtc]: toDate?.toJSON() || '',
    [Const.KeyEndType]: GetKeyEndTypes(selectedEndTypes),
    [Const.KeyType]: String(GetSummaryRuleOptionId(summaryItems)),
  };

  const {
    data: numberOfMaterialSummaryBarData,
    loading: numberOfMaterialSummaryBarLoading,
    error: numberOfMaterialSummaryBarError,
    execute: fetchNumberOfMaterialSummaryBarData,
  } = useGetDashboardData(numberOfMaterialSummaryBarDataUrl, dataParams);

  const {
    data: numberOfMaterialSummaryTableData,
    loading: numberOfMaterialSummaryTableLoading,
    error: numberOfMaterialSummaryTableError,
    execute: fetchNumberOfMaterialSummaryTableData,
  } = useGetDashboardData(numberOfMaterialSummaryTableDataUrl, dataParams);

  useEffect(() => {
    if (summaryItems) {
      // if (fromDate && toDate && summaryItems) {
      reloadData();
      updateSearchParams();
    }
  }, [fromDate, toDate, selectedEndTypes, summaryItems]);

  function reloadData() {
    console.log('reloadData');

    if (!fromDate || !toDate) {
      console.log('Either fromDate or toDate is empty. Aborting reload.');
      return;
    }

    // グラフのデータ再読み込み処理
    fetchNumberOfMaterialSummaryBarData();
    fetchNumberOfMaterialSummaryTableData();
  }

  // URL のクエリパラメータを検索項目に反映
  useEffect(() => {
    const urlParamStartDateTime = searchParams.get('startDateTime') || '';
    const urlParamToDateTime = searchParams.get('toDateTime') || '';
    const urlParamEndType = searchParams.get('endType') || '';
    const urlParamSummaryItems = searchParams.get('summaryItems') || '';
    setFromDate(
      urlParamStartDateTime ? new Date(urlParamStartDateTime) : new Date(defaultFromDate)
    );
    setToDate(urlParamToDateTime ? new Date(urlParamToDateTime) : new Date(defaultToDate));
    setSelectedEndTypes(urlParamEndType ? urlParamEndType.split(',') : selectedEndTypes);
    if (urlParamSummaryItems && !summaryItems) {
      setSummaryItems(urlParamSummaryItems);
    }
  }, []);
  // }, [searchParams]);

  // 入力内容を URL に追加
  const updateSearchParams = () => {
    const params = new URLSearchParams();
    if (fromDate) params.set('startDateTime', fromDate.toISOString());
    if (toDate) params.set('toDateTime', toDate.toISOString());

    // endTypeをカンマ区切りの文字列で設定
    if (selectedEndTypes.length > 0) {
      params.set('endType', selectedEndTypes.join(',')); // 配列をカンマ区切りの文字列に変換
    }

    if (summaryItems) params.set('summaryItems', summaryItems);

    // URLクエリパラメータを更新
    setSearchParams(params);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const headerStyle = import.meta.env.VITE_ENV_VERSION !== 'prod' ? '#111827' : '#00B0B9';

  if (numberOfMaterialSummaryBarLoading || numberOfMaterialSummaryTableLoading)
    return <p>Loading...</p>;
  if (numberOfMaterialSummaryBarError) {
    const errorMessage =
      numberOfMaterialSummaryBarError instanceof Error
        ? numberOfMaterialSummaryBarError.message
        : 'An unknown error occurred';
    return <p>Error: {errorMessage}</p>;
  }
  if (numberOfMaterialSummaryTableError) {
    const errorMessage =
      numberOfMaterialSummaryTableError instanceof Error
        ? numberOfMaterialSummaryTableError.message
        : 'An unknown error occurred';
    return <p>Error: {errorMessage}</p>;
  }

  return (
    <>
      <Sidebar />
      <div
        style={{
          marginLeft: 40,
          width: 'calc(100% - 40px)',
          transition: 'width 0.3s, margin-left 0.3s',
        }}
        className="grid grid-cols-1"
      >
        {/* <div style={{ width: '100%' }} className="grid grid-cols-1"> */}
        <div
          style={{
            position: 'fixed',
            top: '75px',
            zIndex: 999,
            // width: '100%',
            width: 'calc(100% - 40px)',
          }}
        >
          <div className="flex 3xl:hidden justify-end p-2">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded text-white"
              aria-label="検索条件"
              style={{ backgroundColor: headerStyle }}
            >
              <svg width="50" height="50" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M8 12h34M8 25h34M8 38h34" />
              </svg>
            </button>
          </div>
          <div
            className={`
              ${isMenuOpen ? 'block' : 'hidden'}
              3xl:block
              bg-white
            `}
          >
            <div className="p-4">
              <div
                className="p-2"
                style={{
                  borderWidth: '1px',
                  backgroundColor: `${Const.SearchItemColor}`,
                }}
              >
                <div className="flex 3xl:flex-row flex-col gap-8 p-2 mb-0">
                  <div className="flex items-center">
                    <label className="text-base font-bold">{Const.LabelStartDatetimeUtc}</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        format="yyyy/MM/dd HH:mm"
                        value={fromDate}
                        onChange={setFromDate}
                        onClose={() => updateSearchParams()}
                        ampm={false}
                        slotProps={{
                          actionBar: { actions: ['accept'] },
                          textField: {
                            size: 'small',
                            style: {
                              borderColor: `${Const.SearchItemBorderColor}`,
                              width: '200px',
                            },
                            onBlur: () => {
                              updateSearchParams();
                            },
                          },
                        }}
                        slots={{
                          actionBar: (props) => (
                            <>
                              <Button onClick={() => setFromDate(new Date())}>現在時刻</Button>
                              {props.actions?.map((action) => {
                                switch (action) {
                                  case 'accept':
                                    return (
                                      <Button
                                        key="accept"
                                        onClick={() => {
                                          props.onAccept?.();
                                          updateSearchParams();
                                        }}
                                      >
                                        OK
                                      </Button>
                                    );
                                  default:
                                    return null;
                                }
                              })}
                            </>
                          ),
                        }}
                      />
                    </LocalizationProvider>
                    <label className="text-base font-bold ml-4">{Const.LabelToDatetimeUtc}</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        format="yyyy/MM/dd HH:mm"
                        value={toDate}
                        onChange={setToDate}
                        onClose={() => updateSearchParams()}
                        ampm={false}
                        slotProps={{
                          actionBar: { actions: ['accept'] },
                          textField: {
                            size: 'small',
                            style: {
                              borderColor: `${Const.SearchItemBorderColor}`,
                              width: '200px',
                            },
                            onBlur: () => {
                              updateSearchParams();
                            },
                          },
                        }}
                        slots={{
                          actionBar: (props) => (
                            <>
                              <Button onClick={() => setToDate(new Date())}>現在時刻</Button>
                              {props.actions?.map((action) => {
                                switch (action) {
                                  case 'accept':
                                    return (
                                      <Button key="accept" onClick={props.onAccept}>
                                        OK
                                      </Button>
                                    );
                                  default:
                                    return null;
                                }
                              })}
                            </>
                          ),
                        }}
                      />
                    </LocalizationProvider>
                  </div>
                  <DropdownMulti
                    label={Const.LabelEndType}
                    data={Const.EndTypes}
                    selected={selectedEndTypes}
                    onChange={(selected: string[]) => {
                      setSelectedEndTypes(selected);
                      console.log('Selected items:', selected);
                    }}
                  />
                  <div className="items-center">
                    <Dropdown
                      label={Const.LabelSummaryTarget}
                      data={Array.from(Const.SummaryRuleOption.values())}
                      selected={summaryItems}
                      onChange={(selected: string) => {
                        setSummaryItems(selected);
                        console.log('Selected items:', selected);
                      }}
                      disabled={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GraphAreaStudyAdmin
          summaryTableData={numberOfMaterialSummaryTableData}
          numberOfLessonsData={numberOfMaterialSummaryBarData}
          summaryItem={GetSummaryRuleOptionId(summaryItems)}
          startDateTime={fromDate || new Date(defaultFromDate)}
          toDateTime={toDate || new Date(defaultToDate)}
          endType={selectedEndTypes}
        ></GraphAreaStudyAdmin>
      </div>
    </>
  );
}

export default DashboardSelfStudyAdmin;
